import { SIGN_IN_ROUTE } from "utils/routes";

// import {ADA_SERVICE_TOKEN} from '../../Context/AuthProvider/utils';

const CustomFetch = (url, options = {}) => {
    const token = localStorage.getItem('tradez-token');
    const isFormDataRequest =
      typeof FormData !== "undefined" && options.body instanceof FormData;
    const defaultHeaders = {
      'Authorization': `Bearer ${token}`,
    };

    if (!isFormDataRequest) {
      defaultHeaders['Content-Type'] = 'application/json';
    }
  
    const headers = {
      ...defaultHeaders,
      ...options.headers,
    };

    if (isFormDataRequest && headers['Content-Type']) {
      delete headers['Content-Type'];
    }

        const resp = fetch(url, { ...options, headers });

        resp.then(e => e).then(f => {
            if(f.status === 401){
                window.location.href = SIGN_IN_ROUTE;
                // localStorage.clear('tradez-token');
            }
        });

    return resp;
  };

  export default CustomFetch;
